if(!document.querySelector('script[src="https://www.chartjs.org/dist/2.9.3/Chart.min.js"]')) {
    let scriptElement = document.createElement('script');
    scriptElement.src = 'https://www.chartjs.org/dist/2.9.3/Chart.min.js';
    document.head.appendChild(scriptElement);
}

const format = (number) => {
    number = "" + number;
    console.log(number);

    let ret = "";
    let idx = number.length;
    for (let i = number.length - 3; i > 0; i -= 3) {
        ret = number.substring(i, idx) + " " + ret;
        idx = i;
    }
    ret = number.substring(0, idx) + " " + ret;
    return  ret.trim();
};

const MONTH = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"];
if(!customElements.get('content-distribution-price-history')) customElements.define('content-distribution-price-history', class extends HTMLElement {
    connectedCallback() {
        if(window.location.href.includes('akbars')){
            this.style.display = 'none';
            return;
        }
        if (!this.hasAttribute('offer-id') || Number.isNaN(Number.parseInt(this.getAttribute('offer-id')))) {
            this.style.display = 'none';
            return;
        }
        const tryOnce = () => {
            if (typeof Chart !== 'undefined') {
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', () => this.init());
                }
                else {
                    this.init();
                }
            } else {
                setTimeout(tryOnce, 100);
            }
        };
        tryOnce();
    }

    init() {
        const now = new Date();
        now.setTime(now.getTime() + 3 * 60 * 60 * 1000);
        const timestamp = now.toISOString().split("T")[0];
        fetch(`https://cdn.cian.site/finance/content-distribution/price-history/${this.getAttribute('offer-id')}.${timestamp}.json`)
            .then(r => {
                if (!r.ok) {
                    return fetch(`https://price-history-api.content.cian.ru/offer/${this.getAttribute('offer-id')}/price-history`).then(r => r.ok ? r.json() : {}).catch(() => ({}));
                }
                return r.json()
            })
            .catch(() => fetch(`https://price-history-api.content.cian.ru/offer/${this.getAttribute('offer-id')}/price-history`).then(r => r.ok ? r.json() : {}).catch(() => ({})))
            .then(({model}) => this.render(model));
    }

    render(model) {
        if((!model.priceChanges || model.priceChanges.length < 2) && !model.datesLabels) {
            this.style.display = 'none';
            return;
        }
        let config = {
            type: 'line',
            data: {
                labels: model.datesLabels,
                datasets: [{
                    borderColor: '#0468FF',
                    pointHoverBackgroundColor: '#0468FF',
                    pointHoverBorderColor: '#0468FF',
                    pointHoverRadius: 4,
                    pointRadius: 0,
                    pointHitRadius: 4,
                    order: 2,
                    label: "Рыночная цена",
                    data: model.valuationPrices
                }, {
                    borderColor: '#FF1F34',
                    pointHoverBackgroundColor: '#FF1F34',
                    pointHoverBorderColor: '#FF1F34',
                    pointHoverRadius: 4,
                    pointRadius: 0,
                    pointHitRadius: 4,
                    order: 1,
                    stepped: 'before',
                    label: "Цена продавца",
                    data: model.historyPrices
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [{
                        //https://www.chartjs.org/docs/next/axes/styling.html#grid-line-configuration
                        ticks: {
                            //see https://www.chartjs.org/docs/next/axes/radial/linear.html#tick-options
                            backdropColor: 'rgba(21, 34, 66, 0.4)',
                            fontColor: 'rgba(21, 34, 66, 0.4)',
                            padding: 6,
                            callback: (value) => {
                                const d = new Date(value);
                                if(d.getDate() === 1){
                                    return MONTH[d.getMonth()];
                                }
                                return "";
                            },
                            maxRotation: 0,
                            stepSize: 1,
                            maxTicksLimit: 12,
                            lineHeight: 1.5,
                        },
                        gridLines: {
                            //https://www.chartjs.org/docs/next/axes/styling.html#grid-line-configuration
                            zeroLineColor: 'rgba(21, 34, 66, 0.1)',
                            color: 'rgba(21, 34, 66, 0.1)',
                            borderDash: [3, 3],
                            zeroLineBorderDash: [3, 3],
                            tickMarkLength: 5,
                        },
                    }],
                    yAxes: [{
                        min: model.minChartPrice,
                        max: model.maxChartPrice,
                        position: 'right',
                        offset: false,
                        ticks: {
                            //see https://www.chartjs.org/docs/next/axes/radial/linear.html#tick-options
                            fontColor: 'rgba(21, 34, 66, 0.4)',
                            padding: 12,
                            callback: (value) => (value === 0 ? '' : `${format(value)} ₽`),
                        },

                        gridLines: {
                            // https://www.chartjs.org/docs/next/axes/styling.html#grid-line-configuration
                            drawBorder: false,
                            color: 'rgba(21, 34, 66, 0.06)',
                            zeroLineColor: 'transparent',
                            tickMarkLength: 0,
                        },
                    }],
                },
                elements: {
                    line: {
                        tension: 0,
                        borderWidth: 2,
                    },
                    point: {
                        borderWidth: 2,
                    },
                },
                layout: {
                    padding: 0,
                },
                tooltips: {
                    enabled: true,
                    backgroundColor: '#152242',
                    cornerRadius: 4,
                    caretSize: 0,
                    caretPadding: 12,
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: (x) => { console.log(JSON.stringify(x)); return (x.datasetIndex == 0? " Рыночная цена: ": " Цена продавца: ") + format(x.yLabel) + "  ₽"},
                    },
                },
                plugins: {
                    datalabels: {
                        display: false,
                    },
                },
                hover: {
                    mode: 'index',
                    intersect: false,
                },
            }
        };
        let evaluationBlock = "";
        if(model.valuationPrices) {
            evaluationBlock = `<div style="margin: 48px 0 48px;">
<div style="font-family: Proxima Nova;font-style: normal;font-weight: bold;font-size: 22px;line-height: 24px;color: #262C40;">Оценка квартиры от Циан</div>
<div style="display: flex; margin: 14px 0 0; ${window.innerWidth < 1024 ? "flex-direction: column;":""}">
        <div style="flex-grow: 1">
            <div style="display: flex; position: relative; margin-bottom: 8px; color: #262C40;font-family: Proxima Nova;font-style: normal;font-weight: normal;font-size: 16px;line-height: 20px;">
                Рекомендованная рыночная цена
                <span style="position: relative; cursor: pointer">
                    <svg info  onmouseover="this.querySelector('path').style.fill = '#508BE2'" onmouseout="this.querySelector('path').style.fill = '#D7DEE9'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#D7DEE9" d="M12 8.125C11.8523 8.125 11.706 8.0959 11.5695 8.03936C11.433 7.98283 11.309 7.89996 11.2045 7.7955C11.1 7.69103 11.0172 7.56701 10.9606 7.43052C10.9041 7.29403 10.875 7.14774 10.875 7C10.875 6.85226 10.9041 6.70597 10.9606 6.56948C11.0172 6.43299 11.1 6.30897 11.2045 6.2045C11.309 6.10004 11.433 6.01717 11.5695 5.96064C11.706 5.9041 11.8523 5.875 12 5.875C12.2984 5.875 12.5845 5.99353 12.7955 6.2045C13.0065 6.41548 13.125 6.70163 13.125 7C13.125 7.29837 13.0065 7.58452 12.7955 7.7955C12.5845 8.00647 12.2984 8.125 12 8.125ZM13 17.125C13 17.3902 12.8946 17.6446 12.7071 17.8321C12.5196 18.0196 12.2652 18.125 12 18.125C11.7348 18.125 11.4804 18.0196 11.2929 17.8321C11.1054 17.6446 11 17.3902 11 17.125V11C11 10.7348 11.1054 10.4804 11.2929 10.2929C11.4804 10.1054 11.7348 10 12 10C12.2652 10 12.5196 10.1054 12.7071 10.2929C12.8946 10.4804 13 10.7348 13 11V17.125ZM12 2C6.477 2 2 6.478 2 12C2 17.522 6.477 22 12 22C17.522 22 22 17.522 22 12C22 6.478 17.522 2 12 2Z"/>
                    </svg>
                    <div popup style="position: absolute; display: none; width: 257px; height: 104px; left: -93px; top: 31px;background: #E9F1F9;box-shadow: 0px 4px 8px rgba(13, 53, 108, 0.15);">
                        <div style="background: #E9F1F9; width: 10px; height: 10px; transform: rotate(45deg); left: 100px; top: -6px; position: absolute"></div>
                        <div style="margin: 8px 40px 8px 16px; font-family: Proxima Nova;font-style: normal;font-weight: normal;font-size: 14px;line-height: 20px;color: #262C40;">Из базы в 2,5 млн объявлений и сделок выбираем только похожие квартиры, и на их основе рассчитываем оценку</div>
                        <svg style="position: absolute; right: 8px; top: 8px; cursor: pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.4142 12L17.7072 7.70701C18.0982 7.31601 18.0982 6.68401 17.7072 6.29301C17.3162 5.90201 16.6842 5.90201 16.2933 6.29301L12.0002 10.586L7.70725 6.29301C7.31625 5.90201 6.68425 5.90201 6.29325 6.29301C5.90225 6.68401 5.90225 7.31601 6.29325 7.70701L10.5862 12L6.29325 16.293C5.90225 16.684 5.90225 17.316 6.29325 17.707C6.48825 17.902 6.74425 18 7.00025 18C7.25625 18 7.51225 17.902 7.70725 17.707L12.0002 13.414L16.2933 17.707C16.4882 17.902 16.7443 18 17.0002 18C17.2562 18 17.5122 17.902 17.7072 17.707C18.0982 17.316 18.0982 16.684 17.7072 16.293L13.4142 12Z" fill="#D7DEE9"/>
                        </svg>
                    </div>
                </span>
            </div>
            <div style="margin-bottom: 8px; color: #262C40;font-family: Proxima Nova;font-style: normal;font-weight: bold;font-size: 22px;line-height: 24px;">${format(model.valuationPrices[model.valuationPrices.length - 1])} ₽</div>
        </div>
        <div style="flex-grow: 1"><div style="margin-bottom: 8px; color: #7C8793;font-family: Proxima Nova;font-style: normal;font-weight: normal;font-size: 14px;line-height: 20px;text-align: right;">Не является официальной оценкой для ипотеки</div></div>
</div>
</div>`;
        }
        this.innerHTML = `${evaluationBlock}<div>
    <div style="font-family: Proxima Nova;font-style: normal;font-weight: bold;font-size: 22px;line-height: 24px;color: #262C40;">Изменение цены продавцом</div>
    <div style="display: flex; border-bottom: 2px solid #E9F1F9; margin-bottom: 12px; padding: 0px 4px; font-family: Proxima Nova;font-style: normal;font-weight: bold;font-size: 16px;line-height: 20px;">
        <div table-tab style="padding: 10px 0; margin: 0 12px -2px; color: var(--underscore-color); border-bottom: 2px solid var(--underscore-color); cursor: pointer; --underscore-color: var(--link-color)">Таблица</div>
        <div chart-tab style="padding: 10px 0; margin: 0 12px -2px; color: #262C40; border-bottom: 2px solid transparent; cursor: pointer; --underscore-color: var(--link-color)">График</div>
    </div>
    <div>
        <div table></div>
        <div chart style="display: none; width: 100%; min-height: 150px"><canvas></canvas><div style="display: flex; justify-content: flex-end;font-family: Proxima Nova;font-style: normal;font-weight: normal;font-size: 16px;line-height: 20px;color: #262C40;">
        <svg style="margin-top: 3px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="7" width="10" height="2" fill="#C84F4F"/>
        </svg>
        <div>Цена продавца</div>
        <svg style="margin-top: 3px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="7" width="10" height="2" fill="#0057B6"/>
        </svg>
        <div>Рекомендованная рыночная цена</div>

        </div></div>
    </div>
</div>`;
        const ctx = this.querySelector('canvas').getContext("2d");
        this.myLine = new Chart(ctx, config);
        if(model.priceChanges && model.priceChanges.length > 1) {
            const days = Math.round((new Date().getTime() - new Date(model.priceChanges[model.priceChanges.length - 1].changeTime)) / 24 / 60 / 60 / 1000);
            let sufix = "дней";
            if (days % 10 === 1 && days !== 11) {
                sufix = 'день';
            }
            else if([2, 3, 4].indexOf(days % 10) >= 0 && [12, 13, 14].indexOf(days) < 0) {
                sufix = 'дней';
            }
            let prevPrice = 0;
            const table =
                "<table cellspacing='0' cellpadding='0' style='width: 100%;'>" +
                model.priceChanges.map((v, i) => {
                    if(prevPrice === 0) {
                        prevPrice = v.priceData.price;
                        return "";
                    }
                    const change = prevPrice - v.priceData.price;
                    prevPrice = v.priceData.price;
                    const d = new Date(v.changeTime);
                    return `<tr style="background: ${i%2 === 0 ? "#F7F9FB": "white"}">
                        <td style="padding: 16px 0 12px 16px;">${d.getDate()} ${MONTH[d.getMonth()]} ${d.getFullYear()}</td>
                        <td style="text-align: right; padding: 16px 0 12px;">${format(v.priceData.price)} ₽</td>
                        <td style="text-align: right; padding: 16px 16px 12px 0; color: ${change > 0 ? "#C84F4F": "#239C3D"};">${change > 0 ? "+ ": ""}${format(change)} ₽</td>
                    </tr>`
                }).join("\n") + "</table>";
            let html = `
            <div style="display: flex; ${window.innerWidth < 1024 ? "flex-direction: column-reverse;":""}">
                <div style="flex-grow: 1">${table}</div>
                <div style="flex-grow: 1"><div style="margin-bottom: 8px; color: #7C8793;font-family: Proxima Nova;font-style: normal;font-weight: normal;font-size: 14px;line-height: 20px;text-align: right;">Объект в продаже: ${days} ${sufix}</div></div>
            </div>
            `;
            this.querySelector('[table]').innerHTML = html;
        }
        else {
            let e = this.querySelector('[table-tab]');
            e.parentElement.removeChild(e);
            e = this.querySelector('[table]');
            e.parentElement.removeChild(e);
            e = this.querySelector('[chart-tab]');
            e.style.borderBottom = '2px solid var(--underscore-color)';
            e.style.color = 'var(--underscore-color)';
            e = this.querySelector('[chart]');
            e.style.display = 'block';
        }

        this.addEventListener('click', ({target}) =>{
            if(target.closest('[info]')) {
                this.querySelector('[popup]').style.display = 'flex';
            }
            if(target.closest('[popup]')) {
                this.querySelector('[popup]').style.display = 'none';
            }
            if(target.closest('[chart-tab]')) {
                let e = this.querySelector('[chart-tab]');
                e.style.borderBottom = '2px solid var(--underscore-color)';
                e.style.color = 'var(--underscore-color)';
                e = this.querySelector('[chart]');
                e.style.display = 'block';
                e = this.querySelector('[table-tab]');
                e.style.borderBottom = '2px solid transparent';
                e.style.color = '#262C40';
                e = this.querySelector('[table]');
                e.style.display = 'none';
            }
            if(target.closest('[table-tab]')) {
                let e = this.querySelector('[table-tab]');
                e.style.borderBottom = '2px solid var(--underscore-color)';
                e.style.color = 'var(--underscore-color)';
                e = this.querySelector('[table]');
                e.style.display = 'block';
                e = this.querySelector('[chart-tab]');
                e.style.borderBottom = '2px solid transparent';
                e.style.color = '#262C40';
                e = this.querySelector('[chart]');
                e.style.display = 'none';
            }
        })
    }
});